import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commentActions from '../../../actions/commentActions';
import CommentsHeader from './CommentsHeader';
import CommentForm from './CommentForm';
import CommentsList from './CommentsList';
import LoadMoreButton from '../Buttons/LoadMoreButton';

class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitting: false,
    };
  }

  componentDidMount() {
    // Need this as sometimes when loading a session this.props.contentId is already populated
    // So the if statement in componentWillReceiveProps doesn't fire on page load
    if (this.props.contentId) {
      this.getComments(this.props.contentId);
    }
  }

  componentWillReceiveProps(nextProps) {
    // Get comments if the active drill is changed in session template
    if (this.props.contentId !== nextProps.contentId) {
      this.getComments(nextProps.contentId, nextProps.contentType);
    }

    // If we've successfully added a new comment
    if (this.props.comments.count !== nextProps.comments.count) {
      this.setState({ submitting: false });
    }

    // If we've loaded more comments
    if (this.props.comments.data !== nextProps.comments.data) {
      this.setState({ loading: false });
    }
  }

  getComments = (contentId, contentType) => {
    this.props.actions.loadComments(contentId, contentType, 5, '');
  }

  submitComment = (commentText) => {
    this.setState({ submitting: true });
    this.props.actions.addComment(this.props.contentId, this.props.contentType, commentText);
  }

  toggleLike = (commentId, liked, commentOrReply, parentCommentId) => {
    if (liked === true) {
      this.props.actions.removeCommentLike(commentId, this.props.loggedInUser.user_id, commentOrReply, parentCommentId);
    } else {
      this.props.actions.addCommentLike(commentId, this.props.loggedInUser.user_id, commentOrReply, parentCommentId);
    }
  }

  deleteComment = (commentId) => {
    this.props.actions.deleteComment(commentId, 'comment');
  }

  reportComment = (commentId) => {
    this.props.actions.reportComment(commentId, 'comment');
  }

  submitReply = (commentId, replyText) => {
    this.props.actions.replyToComment(commentId, replyText);
  }

  deleteReply = (replyId, parentCommentId) => {
    this.props.actions.deleteComment(replyId, 'reply', parentCommentId);
  }

  reportReply = (replyId, parentCommentId) => {
    this.props.actions.reportComment(replyId, 'reply', parentCommentId);
  }

  loadMoreClick = () => {
    this.setState({ loading: true });
    this.props.actions.loadComments(this.props.contentId, this.props.contentType, 5, this.props.comments.cursor, true);
  }

  render () {
    const { comments, loggedInUser } = this.props;
    const { loading, submitting } = this.state;

    return (
      <div id="comments-anchor" className="comments">
        <CommentsHeader numberOfComments={comments.count} />

        <div className="comments-container border-radius-l overflow-hidden">
          <CommentForm
            loggedInUser={loggedInUser}
            placeholder="Write a comment... press enter to submit"
            onSubmit={this.submitComment}
            btnText="Comment"
            submitting={submitting}
          />

          <CommentsList
            comments={comments.data}
            loggedInUser={loggedInUser}
            toggleLike={this.toggleLike}
            deleteComment={this.deleteComment}
            reportComment={this.reportComment}
            submitReply={this.submitReply}
            deleteReply={this.deleteReply}
            reportReply={this.reportReply}
          />
          <LoadMoreButton
            moreResults={comments.more}
            loadMoreClick={this.loadMoreClick}
            loading={loading}
            classes="comments__load-more-btn"
          />
        </div>
      </div>
    );
  }
}

Comments.propTypes = {
  comments: PropTypes.object.isRequired,
  contentId: PropTypes.number,
  contentType: PropTypes.string,
  loggedInUser: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    comments: state.comments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(commentActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Comments);



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/Comments.js